/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
import { ReportFormatList } from "./ReportFormatList";
import { ReportWorkflowConfig } from "./ReportWorkflowConfig";
import { ValidationConfig } from "./ValidationConfig";
import { ReportTypePagesConfig } from "./ReportTypePagesConfig";
import { ReportFeaturesList } from "./ReportFeaturesList";
import { SerdesUtils } from "@amzn/coral-typescript-types-pieces";
import { CoralModel, modelRegistrySingleton, } from "@amzn/ihm-js-coral-client";
/**
 * <pre><code>Holds a report type configuration.
 * reportTypeDisplayName - Represents display name of report type.
 * featuresList - Holds the features opted for a Term and Report Type. Order of the features in the list is also
 * maintained.
 * reportType - Represents type of report like INVOICE_RECONCILIATION_FILES, INVOICE_DISUPTE_FILES.
 * reportTypeUrlPath - Represents url path for Report type.
 * reportWorkflowConfig - represents the workflow config for the report. Workflow config represents all possible
 * actions for a given workflow state
 * reportFolderViewConfig - represents if the folder view is to be enabled for this report
 * reportFormats - represents the list of report formats that are allowed
 * reportTypePagesConfig - config used by UI client to build Report generation pages dynamically.
 * isExternalAllowed - Represents weather the report type to be accessed in CarrierLogistics UI. If the value is true
 * or null reportType will be accessed in CarrierLogistics UI. If the value is false reportType access will
 * be restricted to Carrier Logistics UI
 * Note : Added only attributes which are required by client as of today.
 * <\/code><\/pre>
 **/
export class ReportConfig extends CoralModel {
    /**
     * @deprecated Clients should not use this constructor directly as it is modified each time the underlying Coral model changes.
     *             Instead, use the ReportConfig#clone(obj: PlainObjectFrom<ReportConfig>) method.
     */
    constructor(__featuresList, __reportType, __reportTypeDisplayName, __reportTypeUrlPath, __isExternalAllowed, __logisticsPartyId, __reportFolderViewConfig, __reportFormats, __reportTypeDescription, __reportTypePagesConfig, __reportWorkflowConfig, __validationConfig) {
        super();
        this.featuresList = __featuresList;
        this.reportType = __reportType;
        this.reportTypeDisplayName = __reportTypeDisplayName;
        this.reportTypeUrlPath = __reportTypeUrlPath;
        this.isExternalAllowed = __isExternalAllowed;
        this.logisticsPartyId = __logisticsPartyId;
        this.reportFolderViewConfig = __reportFolderViewConfig;
        this.reportFormats = __reportFormats;
        this.reportTypeDescription = __reportTypeDescription;
        this.reportTypePagesConfig = __reportTypePagesConfig;
        this.reportWorkflowConfig = __reportWorkflowConfig;
        this.validationConfig = __validationConfig;
    }
    /**
     * Create a shallow clone of ReportConfig from its properties.
     *
     * @return a clone with the same prototype and property values as the given object.
     */
    static clone(obj) {
        return new ReportConfig(obj.featuresList, obj.reportType, obj.reportTypeDisplayName, obj.reportTypeUrlPath, obj.isExternalAllowed, obj.logisticsPartyId, obj.reportFolderViewConfig, obj.reportFormats, obj.reportTypeDescription, obj.reportTypePagesConfig, obj.reportWorkflowConfig, obj.validationConfig);
    }
    static fromJson(data) {
        return new ReportConfig(ReportFeaturesList.fromJson(data.featuresList), SerdesUtils.identityFunction(data.reportType), SerdesUtils.identityFunction(data.reportTypeDisplayName), SerdesUtils.identityFunction(data.reportTypeUrlPath), (($$val) => $$val == undefined ? undefined : SerdesUtils.identityFunction($$val))(data.isExternalAllowed), (($$val) => $$val == undefined ? undefined : SerdesUtils.identityFunction($$val))(data.logisticsPartyId), (($$val) => $$val == undefined ? undefined : SerdesUtils.identityFunction($$val))(data.reportFolderViewConfig), (($$val) => $$val == undefined ? undefined : ReportFormatList.fromJson($$val))(data.reportFormats), (($$val) => $$val == undefined ? undefined : SerdesUtils.identityFunction($$val))(data.reportTypeDescription), (($$val) => $$val == undefined ? undefined : ReportTypePagesConfig.fromJson($$val))(data.reportTypePagesConfig), (($$val) => $$val == undefined ? undefined : ReportWorkflowConfig.fromJson($$val))(data.reportWorkflowConfig), (($$val) => $$val == undefined ? undefined : ValidationConfig.fromJson($$val))(data.validationConfig));
    }
    static toJson(data) {
        return Object.assign({
            featuresList: ReportFeaturesList.toJson(data.featuresList),
            reportType: SerdesUtils.identityFunction(data.reportType),
            reportTypeDisplayName: SerdesUtils.identityFunction(data.reportTypeDisplayName),
            reportTypeUrlPath: SerdesUtils.identityFunction(data.reportTypeUrlPath),
            isExternalAllowed: (($$val) => $$val == undefined ? null : SerdesUtils.identityFunction($$val))(data.isExternalAllowed),
            logisticsPartyId: (($$val) => $$val == undefined ? null : SerdesUtils.identityFunction($$val))(data.logisticsPartyId),
            reportFolderViewConfig: (($$val) => $$val == undefined ? null : SerdesUtils.identityFunction($$val))(data.reportFolderViewConfig),
            reportFormats: (($$val) => $$val == undefined ? null : ReportFormatList.toJson($$val))(data.reportFormats),
            reportTypeDescription: (($$val) => $$val == undefined ? null : SerdesUtils.identityFunction($$val))(data.reportTypeDescription),
            reportTypePagesConfig: (($$val) => $$val == undefined ? null : ReportTypePagesConfig.toJson($$val))(data.reportTypePagesConfig),
            reportWorkflowConfig: (($$val) => $$val == undefined ? null : ReportWorkflowConfig.toJson($$val))(data.reportWorkflowConfig),
            validationConfig: (($$val) => $$val == undefined ? null : ValidationConfig.toJson($$val))(data.validationConfig),
        });
    }
}
ReportConfig.fullyQualifiedTypeName = "com.amazon.transreportscenterservice#ReportConfig";
// Register concrete types for serialization/deserialization
modelRegistrySingleton.registerType(ReportConfig);
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [ReportConfig] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */
export function validateReportconfig(data) {
    // TODO: Actually implement this!
    return data;
}
